import {css} from 'styled-components';

export const quillThemeOverrides = css`
  & .ql-toolbar.ql-snow {
    position: relative;
    border: none;
    border-bottom: 1px solid ${({theme}) => theme.colors.palettes.neutral[30][100]};
    background-color: ${({theme}) => theme.colors.palettes.neutral[10][100]};
    border-radius: 0;
    padding: ${({theme}) => theme.getSize(1)};

    .ql-formats {
      margin-right: ${({theme}) => theme.getSize(1)};

      &:last-child {
        margin-right: 0;
      }
    }

    button {
      width: ${({theme}) => theme.getSize(6)};
      height: ${({theme}) => theme.getSize(6)};
      padding: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
      border-radius: ${({theme}) => theme.radii.small};
      color: ${({theme}) => theme.colors.text.primary};
      transition:
        background-color 0.2s ease-in-out,
        color 0.2s ease-in-out;

      &:hover:not(:disabled) {
        background-color: ${({theme}) => theme.colors.palettes.neutral[30][100]};
      }

      &.ql-active {
        background-color: ${({theme}) => theme.colors.palettes.blue[20][100]};
        color: ${({theme}) => theme.colors.severity.informational};

        &:hover {
          background-color: ${({theme}) => theme.colors.palettes.blue[30][100]};
        }
      }

      &:disabled {
        opacity: 0.4;
        pointer-events: none;
      }

      svg {
        width: 14px !important;
        height: 14px !important;
        display: block;
      }
    }

    .ql-stroke {
      stroke: currentColor;
      stroke-width: 1.5;
    }

    .ql-fill {
      fill: currentColor;
    }

    .ql-picker-label svg {
      width: 14px;
      height: 14px;
    }

    .ql-picker {
      color: ${({theme}) => theme.colors.text.primary};
      font-size: ${({theme}) => theme.fontSizes.text.xSmall};
    }

    .ql-picker-label {
      border-color: transparent !important;

      &:hover {
        border-color: transparent !important;
      }

      .ql-stroke {
        stroke: currentColor;
      }
    }

    .ql-picker-options {
      background-color: ${({theme}) => theme.colors.palettes.white[10][100]};
      border-color: ${({theme}) => theme.colors.palettes.neutral[50][100]};
      border-radius: ${({theme}) => theme.radii.small};
      box-shadow: ${({theme}) => theme.shadows.active};
      padding: ${({theme}) => theme.getSize(1)};
    }

    .ql-picker-item {
      color: ${({theme}) => theme.colors.text.primary};

      &:hover {
        color: ${({theme}) => theme.colors.severity.informational};
      }
    }

    .ql-header {
      .ql-picker-label::before {
        color: ${({theme}) => theme.colors.text.primary};
      }
    }

    .ql-emoji {
      font-size: 16px;
      line-height: 1;

      svg {
        display: none;
      }
    }

    .ql-blockquote {
      font-size: 18px;
      font-weight: bold;
      line-height: 1;

      &::after {
        content: '\\201C';
      }

      svg {
        display: none;
      }
    }
  }

  & .ql-container.ql-snow {
    border: none;
    font-size: ${({theme}) => theme.fontSizes.text.small};
    font-family: inherit;

    .ql-editor {
      padding: ${({theme}) => `${theme.getSize(2)} ${theme.getSize(2)}`};
      color: ${({theme}) => theme.colors.text.primary};
      line-height: ${({theme}) => theme.lineHeights.text.small};

      &.ql-blank::before {
        color: ${({theme}) => theme.colors.text.tertiary};
        font-style: normal;
        left: ${({theme}) => theme.getSize(2)};
      }

      h1 {
        font-size: ${({theme}) => theme.fontSizes.heading.desktop[1]};
        line-height: ${({theme}) => theme.lineHeights.heading.desktop[1]};
        font-weight: ${({theme}) => theme.fontWeights.bold};
      }

      h2 {
        font-size: ${({theme}) => theme.fontSizes.heading.desktop[2]};
        line-height: ${({theme}) => theme.lineHeights.heading.desktop[2]};
        font-weight: ${({theme}) => theme.fontWeights.bold};
      }

      h3 {
        font-size: ${({theme}) => theme.fontSizes.heading.desktop[3]};
        line-height: ${({theme}) => theme.lineHeights.heading.desktop[3]};
        font-weight: ${({theme}) => theme.fontWeights.medium};
      }

      ul,
      ol {
        padding-left: ${({theme}) => theme.getSize(5)};
      }

      blockquote {
        padding-left: ${({theme}) => theme.getSize(2)};
        border-left: 2px solid ${({theme}) => theme.colors.palettes.neutral[50][100]};
        font-style: italic;
        color: ${({theme}) => theme.colors.text.secondary};
      }
    }
  }

  &.ql-disabled {
    .ql-toolbar {
      pointer-events: none;
      opacity: 0.4;
    }

    .ql-container .ql-editor {
      cursor: not-allowed;
      user-select: none;
      background-color: ${({theme}) => theme.colors.palettes.white[10][40]};
    }
  }
`;
